import * as Types from './operations';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const DetectSchemaDocument = gql`
    mutation DetectSchema($data: String!, $key: String!, $env: String) {
  detectDataSchema(args: {data: $data, key: $key, env: $env})
}
    `;
export type DetectSchemaMutationFn = Apollo.MutationFunction<Types.DetectSchemaMutation, Types.DetectSchemaMutationVariables>;

/**
 * __useDetectSchemaMutation__
 *
 * To run a mutation, you first call `useDetectSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetectSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detectSchemaMutation, { data, loading, error }] = useDetectSchemaMutation({
 *   variables: {
 *      data: // value for 'data'
 *      key: // value for 'key'
 *      env: // value for 'env'
 *   },
 * });
 */
export function useDetectSchemaMutation(baseOptions?: Apollo.MutationHookOptions<Types.DetectSchemaMutation, Types.DetectSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DetectSchemaMutation, Types.DetectSchemaMutationVariables>(DetectSchemaDocument, options);
      }
export type DetectSchemaMutationHookResult = ReturnType<typeof useDetectSchemaMutation>;
export type DetectSchemaMutationResult = Apollo.MutationResult<Types.DetectSchemaMutation>;
export type DetectSchemaMutationOptions = Apollo.BaseMutationOptions<Types.DetectSchemaMutation, Types.DetectSchemaMutationVariables>;
export const CreateEndpointDocument = gql`
    mutation CreateEndpoint($uuid: ID!, $packageVersionUuid: String!, $webServiceUuid: String!, $name: String!, $description: String!, $schema: JSON!) {
  createEndpoint(
    args: {uuid: $uuid, packageVersionUuid: $packageVersionUuid, webServiceUuid: $webServiceUuid, name: $name, description: $description, schema: $schema}
  )
}
    `;
export type CreateEndpointMutationFn = Apollo.MutationFunction<Types.CreateEndpointMutation, Types.CreateEndpointMutationVariables>;

/**
 * __useCreateEndpointMutation__
 *
 * To run a mutation, you first call `useCreateEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEndpointMutation, { data, loading, error }] = useCreateEndpointMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      webServiceUuid: // value for 'webServiceUuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useCreateEndpointMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateEndpointMutation, Types.CreateEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateEndpointMutation, Types.CreateEndpointMutationVariables>(CreateEndpointDocument, options);
      }
export type CreateEndpointMutationHookResult = ReturnType<typeof useCreateEndpointMutation>;
export type CreateEndpointMutationResult = Apollo.MutationResult<Types.CreateEndpointMutation>;
export type CreateEndpointMutationOptions = Apollo.BaseMutationOptions<Types.CreateEndpointMutation, Types.CreateEndpointMutationVariables>;
export const DeleteEndpointDocument = gql`
    mutation DeleteEndpoint($packageVersionUuid: String!, $uuid: String!) {
  deleteEndpoint(packageVersionUuid: $packageVersionUuid, uuid: $uuid)
}
    `;
export type DeleteEndpointMutationFn = Apollo.MutationFunction<Types.DeleteEndpointMutation, Types.DeleteEndpointMutationVariables>;

/**
 * __useDeleteEndpointMutation__
 *
 * To run a mutation, you first call `useDeleteEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEndpointMutation, { data, loading, error }] = useDeleteEndpointMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteEndpointMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteEndpointMutation, Types.DeleteEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteEndpointMutation, Types.DeleteEndpointMutationVariables>(DeleteEndpointDocument, options);
      }
export type DeleteEndpointMutationHookResult = ReturnType<typeof useDeleteEndpointMutation>;
export type DeleteEndpointMutationResult = Apollo.MutationResult<Types.DeleteEndpointMutation>;
export type DeleteEndpointMutationOptions = Apollo.BaseMutationOptions<Types.DeleteEndpointMutation, Types.DeleteEndpointMutationVariables>;
export const UpdateEndpointDocument = gql`
    mutation UpdateEndpoint($packageVersionUuid: String!, $uuid: String!, $name: String!, $description: String!) {
  updateEndpoint(
    packageVersionUuid: $packageVersionUuid
    args: {uuid: $uuid, name: $name, description: $description}
  )
}
    `;
export type UpdateEndpointMutationFn = Apollo.MutationFunction<Types.UpdateEndpointMutation, Types.UpdateEndpointMutationVariables>;

/**
 * __useUpdateEndpointMutation__
 *
 * To run a mutation, you first call `useUpdateEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndpointMutation, { data, loading, error }] = useUpdateEndpointMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateEndpointMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateEndpointMutation, Types.UpdateEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateEndpointMutation, Types.UpdateEndpointMutationVariables>(UpdateEndpointDocument, options);
      }
export type UpdateEndpointMutationHookResult = ReturnType<typeof useUpdateEndpointMutation>;
export type UpdateEndpointMutationResult = Apollo.MutationResult<Types.UpdateEndpointMutation>;
export type UpdateEndpointMutationOptions = Apollo.BaseMutationOptions<Types.UpdateEndpointMutation, Types.UpdateEndpointMutationVariables>;
export const UpdateEndpointSchemaDocument = gql`
    mutation UpdateEndpointSchema($packageVersionUuid: String!, $uuid: String!, $schema: JSON!) {
  updateEndpointSchema(
    packageVersionUuid: $packageVersionUuid
    args: {uuid: $uuid, schema: $schema}
  )
}
    `;
export type UpdateEndpointSchemaMutationFn = Apollo.MutationFunction<Types.UpdateEndpointSchemaMutation, Types.UpdateEndpointSchemaMutationVariables>;

/**
 * __useUpdateEndpointSchemaMutation__
 *
 * To run a mutation, you first call `useUpdateEndpointSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndpointSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndpointSchemaMutation, { data, loading, error }] = useUpdateEndpointSchemaMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useUpdateEndpointSchemaMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateEndpointSchemaMutation, Types.UpdateEndpointSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateEndpointSchemaMutation, Types.UpdateEndpointSchemaMutationVariables>(UpdateEndpointSchemaDocument, options);
      }
export type UpdateEndpointSchemaMutationHookResult = ReturnType<typeof useUpdateEndpointSchemaMutation>;
export type UpdateEndpointSchemaMutationResult = Apollo.MutationResult<Types.UpdateEndpointSchemaMutation>;
export type UpdateEndpointSchemaMutationOptions = Apollo.BaseMutationOptions<Types.UpdateEndpointSchemaMutation, Types.UpdateEndpointSchemaMutationVariables>;
export const ExecuteButtonCommandDocument = gql`
    mutation ExecuteButtonCommand($uuid: String!, $packageVersionUuid: String!, $flowUuid: String, $pipelineKey: String, $componentKey: String!, $payload: JSON, $accountUuid: String, $host: String) {
  executeButtonCommand(
    args: {uuid: $uuid, componentKey: $componentKey, packageVersionUuid: $packageVersionUuid, payload: $payload, flowUuid: $flowUuid, pipelineKey: $pipelineKey, accountUuid: $accountUuid, host: $host}
  ) {
    uuid
  }
}
    `;
export type ExecuteButtonCommandMutationFn = Apollo.MutationFunction<Types.ExecuteButtonCommandMutation, Types.ExecuteButtonCommandMutationVariables>;

/**
 * __useExecuteButtonCommandMutation__
 *
 * To run a mutation, you first call `useExecuteButtonCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteButtonCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeButtonCommandMutation, { data, loading, error }] = useExecuteButtonCommandMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      flowUuid: // value for 'flowUuid'
 *      pipelineKey: // value for 'pipelineKey'
 *      componentKey: // value for 'componentKey'
 *      payload: // value for 'payload'
 *      accountUuid: // value for 'accountUuid'
 *      host: // value for 'host'
 *   },
 * });
 */
export function useExecuteButtonCommandMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExecuteButtonCommandMutation, Types.ExecuteButtonCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExecuteButtonCommandMutation, Types.ExecuteButtonCommandMutationVariables>(ExecuteButtonCommandDocument, options);
      }
export type ExecuteButtonCommandMutationHookResult = ReturnType<typeof useExecuteButtonCommandMutation>;
export type ExecuteButtonCommandMutationResult = Apollo.MutationResult<Types.ExecuteButtonCommandMutation>;
export type ExecuteButtonCommandMutationOptions = Apollo.BaseMutationOptions<Types.ExecuteButtonCommandMutation, Types.ExecuteButtonCommandMutationVariables>;
export const ExecuteRequestDocument = gql`
    mutation ExecuteRequest($uuid: String!, $method: String!, $url: String!, $headers: [[String!]!], $body: String, $authentication: AuthenticationInput) {
  executeRequest(
    args: {uuid: $uuid, method: $method, url: $url, headers: $headers, body: $body, authentication: $authentication}
  ) {
    resultCode
    resultBody
    headers
  }
}
    `;
export type ExecuteRequestMutationFn = Apollo.MutationFunction<Types.ExecuteRequestMutation, Types.ExecuteRequestMutationVariables>;

/**
 * __useExecuteRequestMutation__
 *
 * To run a mutation, you first call `useExecuteRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeRequestMutation, { data, loading, error }] = useExecuteRequestMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      method: // value for 'method'
 *      url: // value for 'url'
 *      headers: // value for 'headers'
 *      body: // value for 'body'
 *      authentication: // value for 'authentication'
 *   },
 * });
 */
export function useExecuteRequestMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExecuteRequestMutation, Types.ExecuteRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExecuteRequestMutation, Types.ExecuteRequestMutationVariables>(ExecuteRequestDocument, options);
      }
export type ExecuteRequestMutationHookResult = ReturnType<typeof useExecuteRequestMutation>;
export type ExecuteRequestMutationResult = Apollo.MutationResult<Types.ExecuteRequestMutation>;
export type ExecuteRequestMutationOptions = Apollo.BaseMutationOptions<Types.ExecuteRequestMutation, Types.ExecuteRequestMutationVariables>;
export const ExecuteStatusCommandDocument = gql`
    mutation ExecuteStatusCommand($uuid: String!) {
  executeStatusCommand(args: {uuid: $uuid}) {
    exchangeName
    queueName
  }
}
    `;
export type ExecuteStatusCommandMutationFn = Apollo.MutationFunction<Types.ExecuteStatusCommandMutation, Types.ExecuteStatusCommandMutationVariables>;

/**
 * __useExecuteStatusCommandMutation__
 *
 * To run a mutation, you first call `useExecuteStatusCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteStatusCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeStatusCommandMutation, { data, loading, error }] = useExecuteStatusCommandMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useExecuteStatusCommandMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExecuteStatusCommandMutation, Types.ExecuteStatusCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExecuteStatusCommandMutation, Types.ExecuteStatusCommandMutationVariables>(ExecuteStatusCommandDocument, options);
      }
export type ExecuteStatusCommandMutationHookResult = ReturnType<typeof useExecuteStatusCommandMutation>;
export type ExecuteStatusCommandMutationResult = Apollo.MutationResult<Types.ExecuteStatusCommandMutation>;
export type ExecuteStatusCommandMutationOptions = Apollo.BaseMutationOptions<Types.ExecuteStatusCommandMutation, Types.ExecuteStatusCommandMutationVariables>;
export const CreateFlowDocument = gql`
    mutation CreateFlow($uuid: ID!, $packageVersionUuid: String!, $name: String!, $description: String!, $schema: JSON!) {
  createFlow(
    args: {uuid: $uuid, packageVersionUuid: $packageVersionUuid, name: $name, description: $description, schema: $schema}
  )
}
    `;
export type CreateFlowMutationFn = Apollo.MutationFunction<Types.CreateFlowMutation, Types.CreateFlowMutationVariables>;

/**
 * __useCreateFlowMutation__
 *
 * To run a mutation, you first call `useCreateFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFlowMutation, { data, loading, error }] = useCreateFlowMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useCreateFlowMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFlowMutation, Types.CreateFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFlowMutation, Types.CreateFlowMutationVariables>(CreateFlowDocument, options);
      }
export type CreateFlowMutationHookResult = ReturnType<typeof useCreateFlowMutation>;
export type CreateFlowMutationResult = Apollo.MutationResult<Types.CreateFlowMutation>;
export type CreateFlowMutationOptions = Apollo.BaseMutationOptions<Types.CreateFlowMutation, Types.CreateFlowMutationVariables>;
export const DeleteFlowDocument = gql`
    mutation DeleteFlow($packageVersionUuid: String!, $uuid: String!) {
  deleteFlow(packageVersionUuid: $packageVersionUuid, uuid: $uuid)
}
    `;
export type DeleteFlowMutationFn = Apollo.MutationFunction<Types.DeleteFlowMutation, Types.DeleteFlowMutationVariables>;

/**
 * __useDeleteFlowMutation__
 *
 * To run a mutation, you first call `useDeleteFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFlowMutation, { data, loading, error }] = useDeleteFlowMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteFlowMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFlowMutation, Types.DeleteFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFlowMutation, Types.DeleteFlowMutationVariables>(DeleteFlowDocument, options);
      }
export type DeleteFlowMutationHookResult = ReturnType<typeof useDeleteFlowMutation>;
export type DeleteFlowMutationResult = Apollo.MutationResult<Types.DeleteFlowMutation>;
export type DeleteFlowMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFlowMutation, Types.DeleteFlowMutationVariables>;
export const UpdateFlowDocument = gql`
    mutation UpdateFlow($packageVersionUuid: String!, $uuid: String!, $name: String!, $description: String!) {
  updateFlow(
    packageVersionUuid: $packageVersionUuid
    args: {uuid: $uuid, name: $name, description: $description}
  )
}
    `;
export type UpdateFlowMutationFn = Apollo.MutationFunction<Types.UpdateFlowMutation, Types.UpdateFlowMutationVariables>;

/**
 * __useUpdateFlowMutation__
 *
 * To run a mutation, you first call `useUpdateFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFlowMutation, { data, loading, error }] = useUpdateFlowMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateFlowMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFlowMutation, Types.UpdateFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFlowMutation, Types.UpdateFlowMutationVariables>(UpdateFlowDocument, options);
      }
export type UpdateFlowMutationHookResult = ReturnType<typeof useUpdateFlowMutation>;
export type UpdateFlowMutationResult = Apollo.MutationResult<Types.UpdateFlowMutation>;
export type UpdateFlowMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFlowMutation, Types.UpdateFlowMutationVariables>;
export const UpdateFlowSchemaDocument = gql`
    mutation UpdateFlowSchema($packageVersionUuid: String!, $uuid: String!, $schema: JSON!) {
  updateFlowSchema(
    packageVersionUuid: $packageVersionUuid
    args: {uuid: $uuid, schema: $schema}
  )
}
    `;
export type UpdateFlowSchemaMutationFn = Apollo.MutationFunction<Types.UpdateFlowSchemaMutation, Types.UpdateFlowSchemaMutationVariables>;

/**
 * __useUpdateFlowSchemaMutation__
 *
 * To run a mutation, you first call `useUpdateFlowSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFlowSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFlowSchemaMutation, { data, loading, error }] = useUpdateFlowSchemaMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useUpdateFlowSchemaMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFlowSchemaMutation, Types.UpdateFlowSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFlowSchemaMutation, Types.UpdateFlowSchemaMutationVariables>(UpdateFlowSchemaDocument, options);
      }
export type UpdateFlowSchemaMutationHookResult = ReturnType<typeof useUpdateFlowSchemaMutation>;
export type UpdateFlowSchemaMutationResult = Apollo.MutationResult<Types.UpdateFlowSchemaMutation>;
export type UpdateFlowSchemaMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFlowSchemaMutation, Types.UpdateFlowSchemaMutationVariables>;
export const CreateMappingDocument = gql`
    mutation CreateMapping($uuid: ID!, $packageVersionUuid: String!, $name: String!, $description: String!, $schema: JSON!) {
  createMapping(
    args: {uuid: $uuid, packageVersionUuid: $packageVersionUuid, name: $name, description: $description, schema: $schema}
  )
}
    `;
export type CreateMappingMutationFn = Apollo.MutationFunction<Types.CreateMappingMutation, Types.CreateMappingMutationVariables>;

/**
 * __useCreateMappingMutation__
 *
 * To run a mutation, you first call `useCreateMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMappingMutation, { data, loading, error }] = useCreateMappingMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useCreateMappingMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateMappingMutation, Types.CreateMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateMappingMutation, Types.CreateMappingMutationVariables>(CreateMappingDocument, options);
      }
export type CreateMappingMutationHookResult = ReturnType<typeof useCreateMappingMutation>;
export type CreateMappingMutationResult = Apollo.MutationResult<Types.CreateMappingMutation>;
export type CreateMappingMutationOptions = Apollo.BaseMutationOptions<Types.CreateMappingMutation, Types.CreateMappingMutationVariables>;
export const DeleteMappingDocument = gql`
    mutation DeleteMapping($packageVersionUuid: String!, $uuid: String!) {
  deleteMapping(packageVersionUuid: $packageVersionUuid, uuid: $uuid)
}
    `;
export type DeleteMappingMutationFn = Apollo.MutationFunction<Types.DeleteMappingMutation, Types.DeleteMappingMutationVariables>;

/**
 * __useDeleteMappingMutation__
 *
 * To run a mutation, you first call `useDeleteMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMappingMutation, { data, loading, error }] = useDeleteMappingMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteMappingMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMappingMutation, Types.DeleteMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMappingMutation, Types.DeleteMappingMutationVariables>(DeleteMappingDocument, options);
      }
export type DeleteMappingMutationHookResult = ReturnType<typeof useDeleteMappingMutation>;
export type DeleteMappingMutationResult = Apollo.MutationResult<Types.DeleteMappingMutation>;
export type DeleteMappingMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMappingMutation, Types.DeleteMappingMutationVariables>;
export const UpdateMappingDocument = gql`
    mutation UpdateMapping($packageVersionUuid: String!, $uuid: String!, $name: String!, $description: String!) {
  updateMapping(
    packageVersionUuid: $packageVersionUuid
    args: {uuid: $uuid, name: $name, description: $description}
  )
}
    `;
export type UpdateMappingMutationFn = Apollo.MutationFunction<Types.UpdateMappingMutation, Types.UpdateMappingMutationVariables>;

/**
 * __useUpdateMappingMutation__
 *
 * To run a mutation, you first call `useUpdateMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMappingMutation, { data, loading, error }] = useUpdateMappingMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateMappingMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMappingMutation, Types.UpdateMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMappingMutation, Types.UpdateMappingMutationVariables>(UpdateMappingDocument, options);
      }
export type UpdateMappingMutationHookResult = ReturnType<typeof useUpdateMappingMutation>;
export type UpdateMappingMutationResult = Apollo.MutationResult<Types.UpdateMappingMutation>;
export type UpdateMappingMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMappingMutation, Types.UpdateMappingMutationVariables>;
export const UpdateMappingSchemaDocument = gql`
    mutation UpdateMappingSchema($packageVersionUuid: String!, $uuid: String!, $schema: JSON!) {
  updateMappingSchema(
    packageVersionUuid: $packageVersionUuid
    args: {uuid: $uuid, schema: $schema}
  )
}
    `;
export type UpdateMappingSchemaMutationFn = Apollo.MutationFunction<Types.UpdateMappingSchemaMutation, Types.UpdateMappingSchemaMutationVariables>;

/**
 * __useUpdateMappingSchemaMutation__
 *
 * To run a mutation, you first call `useUpdateMappingSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMappingSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMappingSchemaMutation, { data, loading, error }] = useUpdateMappingSchemaMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useUpdateMappingSchemaMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMappingSchemaMutation, Types.UpdateMappingSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMappingSchemaMutation, Types.UpdateMappingSchemaMutationVariables>(UpdateMappingSchemaDocument, options);
      }
export type UpdateMappingSchemaMutationHookResult = ReturnType<typeof useUpdateMappingSchemaMutation>;
export type UpdateMappingSchemaMutationResult = Apollo.MutationResult<Types.UpdateMappingSchemaMutation>;
export type UpdateMappingSchemaMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMappingSchemaMutation, Types.UpdateMappingSchemaMutationVariables>;
export const CreateMockDataDocument = gql`
    mutation CreateMockData($uuid: ID!, $packageVersionUuid: String!, $name: String!, $description: String!, $source: JSON!, $data: String, $modelUuid: String, $endpointUuid: String, $mappingUuid: String) {
  createMockData(
    args: {uuid: $uuid, packageVersionUuid: $packageVersionUuid, name: $name, description: $description, source: $source, data: $data, modelUuid: $modelUuid, endpointUuid: $endpointUuid, mappingUuid: $mappingUuid}
  )
}
    `;
export type CreateMockDataMutationFn = Apollo.MutationFunction<Types.CreateMockDataMutation, Types.CreateMockDataMutationVariables>;

/**
 * __useCreateMockDataMutation__
 *
 * To run a mutation, you first call `useCreateMockDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMockDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMockDataMutation, { data, loading, error }] = useCreateMockDataMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      source: // value for 'source'
 *      data: // value for 'data'
 *      modelUuid: // value for 'modelUuid'
 *      endpointUuid: // value for 'endpointUuid'
 *      mappingUuid: // value for 'mappingUuid'
 *   },
 * });
 */
export function useCreateMockDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateMockDataMutation, Types.CreateMockDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateMockDataMutation, Types.CreateMockDataMutationVariables>(CreateMockDataDocument, options);
      }
export type CreateMockDataMutationHookResult = ReturnType<typeof useCreateMockDataMutation>;
export type CreateMockDataMutationResult = Apollo.MutationResult<Types.CreateMockDataMutation>;
export type CreateMockDataMutationOptions = Apollo.BaseMutationOptions<Types.CreateMockDataMutation, Types.CreateMockDataMutationVariables>;
export const DeleteMockDataDocument = gql`
    mutation deleteMockData($packageVersionUuid: String!, $uuid: String!) {
  deleteMockData(packageVersionUuid: $packageVersionUuid, uuid: $uuid)
}
    `;
export type DeleteMockDataMutationFn = Apollo.MutationFunction<Types.DeleteMockDataMutation, Types.DeleteMockDataMutationVariables>;

/**
 * __useDeleteMockDataMutation__
 *
 * To run a mutation, you first call `useDeleteMockDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMockDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMockDataMutation, { data, loading, error }] = useDeleteMockDataMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteMockDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMockDataMutation, Types.DeleteMockDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMockDataMutation, Types.DeleteMockDataMutationVariables>(DeleteMockDataDocument, options);
      }
export type DeleteMockDataMutationHookResult = ReturnType<typeof useDeleteMockDataMutation>;
export type DeleteMockDataMutationResult = Apollo.MutationResult<Types.DeleteMockDataMutation>;
export type DeleteMockDataMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMockDataMutation, Types.DeleteMockDataMutationVariables>;
export const UpdateMockDataDocument = gql`
    mutation UpdateMockData($packageVersionUuid: String!, $uuid: String!, $name: String!, $description: String!, $source: JSON!, $data: String, $modelUuid: String, $endpointUuid: String, $mappingUuid: String) {
  updateMockData(
    packageVersionUuid: $packageVersionUuid
    args: {uuid: $uuid, name: $name, description: $description, source: $source, data: $data, packageVersionUuid: $packageVersionUuid, modelUuid: $modelUuid, endpointUuid: $endpointUuid, mappingUuid: $mappingUuid}
  ) {
    uuid
    name
    description
    data
  }
}
    `;
export type UpdateMockDataMutationFn = Apollo.MutationFunction<Types.UpdateMockDataMutation, Types.UpdateMockDataMutationVariables>;

/**
 * __useUpdateMockDataMutation__
 *
 * To run a mutation, you first call `useUpdateMockDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMockDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMockDataMutation, { data, loading, error }] = useUpdateMockDataMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      source: // value for 'source'
 *      data: // value for 'data'
 *      modelUuid: // value for 'modelUuid'
 *      endpointUuid: // value for 'endpointUuid'
 *      mappingUuid: // value for 'mappingUuid'
 *   },
 * });
 */
export function useUpdateMockDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMockDataMutation, Types.UpdateMockDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMockDataMutation, Types.UpdateMockDataMutationVariables>(UpdateMockDataDocument, options);
      }
export type UpdateMockDataMutationHookResult = ReturnType<typeof useUpdateMockDataMutation>;
export type UpdateMockDataMutationResult = Apollo.MutationResult<Types.UpdateMockDataMutation>;
export type UpdateMockDataMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMockDataMutation, Types.UpdateMockDataMutationVariables>;
export const CreateModelDocument = gql`
    mutation CreateModel($uuid: ID!, $packageVersionUuid: String!, $name: String!, $description: String!, $schema: JSON!) {
  createModel(
    args: {uuid: $uuid, packageVersionUuid: $packageVersionUuid, name: $name, description: $description, schema: $schema}
  )
}
    `;
export type CreateModelMutationFn = Apollo.MutationFunction<Types.CreateModelMutation, Types.CreateModelMutationVariables>;

/**
 * __useCreateModelMutation__
 *
 * To run a mutation, you first call `useCreateModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModelMutation, { data, loading, error }] = useCreateModelMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useCreateModelMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateModelMutation, Types.CreateModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateModelMutation, Types.CreateModelMutationVariables>(CreateModelDocument, options);
      }
export type CreateModelMutationHookResult = ReturnType<typeof useCreateModelMutation>;
export type CreateModelMutationResult = Apollo.MutationResult<Types.CreateModelMutation>;
export type CreateModelMutationOptions = Apollo.BaseMutationOptions<Types.CreateModelMutation, Types.CreateModelMutationVariables>;
export const DeleteModelDocument = gql`
    mutation DeleteModel($packageVersionUuid: String!, $uuid: String!) {
  deleteModel(packageVersionUuid: $packageVersionUuid, uuid: $uuid)
}
    `;
export type DeleteModelMutationFn = Apollo.MutationFunction<Types.DeleteModelMutation, Types.DeleteModelMutationVariables>;

/**
 * __useDeleteModelMutation__
 *
 * To run a mutation, you first call `useDeleteModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModelMutation, { data, loading, error }] = useDeleteModelMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteModelMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteModelMutation, Types.DeleteModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteModelMutation, Types.DeleteModelMutationVariables>(DeleteModelDocument, options);
      }
export type DeleteModelMutationHookResult = ReturnType<typeof useDeleteModelMutation>;
export type DeleteModelMutationResult = Apollo.MutationResult<Types.DeleteModelMutation>;
export type DeleteModelMutationOptions = Apollo.BaseMutationOptions<Types.DeleteModelMutation, Types.DeleteModelMutationVariables>;
export const UpdateModelDocument = gql`
    mutation UpdateModel($packageVersionUuid: String!, $uuid: String!, $name: String!, $description: String!) {
  updateModel(
    packageVersionUuid: $packageVersionUuid
    args: {uuid: $uuid, name: $name, description: $description}
  )
}
    `;
export type UpdateModelMutationFn = Apollo.MutationFunction<Types.UpdateModelMutation, Types.UpdateModelMutationVariables>;

/**
 * __useUpdateModelMutation__
 *
 * To run a mutation, you first call `useUpdateModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelMutation, { data, loading, error }] = useUpdateModelMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateModelMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateModelMutation, Types.UpdateModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateModelMutation, Types.UpdateModelMutationVariables>(UpdateModelDocument, options);
      }
export type UpdateModelMutationHookResult = ReturnType<typeof useUpdateModelMutation>;
export type UpdateModelMutationResult = Apollo.MutationResult<Types.UpdateModelMutation>;
export type UpdateModelMutationOptions = Apollo.BaseMutationOptions<Types.UpdateModelMutation, Types.UpdateModelMutationVariables>;
export const UpdateModelSchemaDocument = gql`
    mutation UpdateModelSchema($packageVersionUuid: String!, $uuid: String!, $schema: JSON!) {
  updateModelSchema(
    packageVersionUuid: $packageVersionUuid
    args: {uuid: $uuid, schema: $schema}
  )
}
    `;
export type UpdateModelSchemaMutationFn = Apollo.MutationFunction<Types.UpdateModelSchemaMutation, Types.UpdateModelSchemaMutationVariables>;

/**
 * __useUpdateModelSchemaMutation__
 *
 * To run a mutation, you first call `useUpdateModelSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelSchemaMutation, { data, loading, error }] = useUpdateModelSchemaMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useUpdateModelSchemaMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateModelSchemaMutation, Types.UpdateModelSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateModelSchemaMutation, Types.UpdateModelSchemaMutationVariables>(UpdateModelSchemaDocument, options);
      }
export type UpdateModelSchemaMutationHookResult = ReturnType<typeof useUpdateModelSchemaMutation>;
export type UpdateModelSchemaMutationResult = Apollo.MutationResult<Types.UpdateModelSchemaMutation>;
export type UpdateModelSchemaMutationOptions = Apollo.BaseMutationOptions<Types.UpdateModelSchemaMutation, Types.UpdateModelSchemaMutationVariables>;
export const ValidateStructureSchemaDocument = gql`
    mutation ValidateStructureSchema($schema: JSON!) {
  validateStructureSchema(args: {schema: $schema}) {
    isValid
  }
}
    `;
export type ValidateStructureSchemaMutationFn = Apollo.MutationFunction<Types.ValidateStructureSchemaMutation, Types.ValidateStructureSchemaMutationVariables>;

/**
 * __useValidateStructureSchemaMutation__
 *
 * To run a mutation, you first call `useValidateStructureSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateStructureSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateStructureSchemaMutation, { data, loading, error }] = useValidateStructureSchemaMutation({
 *   variables: {
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useValidateStructureSchemaMutation(baseOptions?: Apollo.MutationHookOptions<Types.ValidateStructureSchemaMutation, Types.ValidateStructureSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ValidateStructureSchemaMutation, Types.ValidateStructureSchemaMutationVariables>(ValidateStructureSchemaDocument, options);
      }
export type ValidateStructureSchemaMutationHookResult = ReturnType<typeof useValidateStructureSchemaMutation>;
export type ValidateStructureSchemaMutationResult = Apollo.MutationResult<Types.ValidateStructureSchemaMutation>;
export type ValidateStructureSchemaMutationOptions = Apollo.BaseMutationOptions<Types.ValidateStructureSchemaMutation, Types.ValidateStructureSchemaMutationVariables>;
export const CreatePackageDocument = gql`
    mutation CreatePackage($uuid: String!, $companyUuid: String!, $packageVersionUuid: String!, $name: String!, $description: String!) {
  createPackage(
    args: {uuid: $uuid, companyUuid: $companyUuid, packageVersionUuid: $packageVersionUuid, name: $name, description: $description}
  )
}
    `;
export type CreatePackageMutationFn = Apollo.MutationFunction<Types.CreatePackageMutation, Types.CreatePackageMutationVariables>;

/**
 * __useCreatePackageMutation__
 *
 * To run a mutation, you first call `useCreatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageMutation, { data, loading, error }] = useCreatePackageMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      companyUuid: // value for 'companyUuid'
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreatePackageMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePackageMutation, Types.CreatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePackageMutation, Types.CreatePackageMutationVariables>(CreatePackageDocument, options);
      }
export type CreatePackageMutationHookResult = ReturnType<typeof useCreatePackageMutation>;
export type CreatePackageMutationResult = Apollo.MutationResult<Types.CreatePackageMutation>;
export type CreatePackageMutationOptions = Apollo.BaseMutationOptions<Types.CreatePackageMutation, Types.CreatePackageMutationVariables>;
export const DeletePackageDocument = gql`
    mutation DeletePackage($uuid: String!) {
  deletePackage(uuid: $uuid)
}
    `;
export type DeletePackageMutationFn = Apollo.MutationFunction<Types.DeletePackageMutation, Types.DeletePackageMutationVariables>;

/**
 * __useDeletePackageMutation__
 *
 * To run a mutation, you first call `useDeletePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageMutation, { data, loading, error }] = useDeletePackageMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeletePackageMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePackageMutation, Types.DeletePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePackageMutation, Types.DeletePackageMutationVariables>(DeletePackageDocument, options);
      }
export type DeletePackageMutationHookResult = ReturnType<typeof useDeletePackageMutation>;
export type DeletePackageMutationResult = Apollo.MutationResult<Types.DeletePackageMutation>;
export type DeletePackageMutationOptions = Apollo.BaseMutationOptions<Types.DeletePackageMutation, Types.DeletePackageMutationVariables>;
export const UpdatePackageDocument = gql`
    mutation UpdatePackage($uuid: String!, $name: String!, $description: String!, $companyUuid: String!) {
  updatePackage(
    args: {uuid: $uuid, description: $description, name: $name, companyUuid: $companyUuid}
  )
}
    `;
export type UpdatePackageMutationFn = Apollo.MutationFunction<Types.UpdatePackageMutation, Types.UpdatePackageMutationVariables>;

/**
 * __useUpdatePackageMutation__
 *
 * To run a mutation, you first call `useUpdatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageMutation, { data, loading, error }] = useUpdatePackageMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      companyUuid: // value for 'companyUuid'
 *   },
 * });
 */
export function useUpdatePackageMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePackageMutation, Types.UpdatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePackageMutation, Types.UpdatePackageMutationVariables>(UpdatePackageDocument, options);
      }
export type UpdatePackageMutationHookResult = ReturnType<typeof useUpdatePackageMutation>;
export type UpdatePackageMutationResult = Apollo.MutationResult<Types.UpdatePackageMutation>;
export type UpdatePackageMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePackageMutation, Types.UpdatePackageMutationVariables>;
export const CreatePackageVersionDocument = gql`
    mutation CreatePackageVersion($uuid: String!, $packageUuid: String!, $variables: JSON!, $version: String!, $createdBy: String!) {
  createPackageVersion(
    args: {uuid: $uuid, packageUuid: $packageUuid, version: $version, createdBy: $createdBy, variables: $variables}
  )
}
    `;
export type CreatePackageVersionMutationFn = Apollo.MutationFunction<Types.CreatePackageVersionMutation, Types.CreatePackageVersionMutationVariables>;

/**
 * __useCreatePackageVersionMutation__
 *
 * To run a mutation, you first call `useCreatePackageVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageVersionMutation, { data, loading, error }] = useCreatePackageVersionMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      packageUuid: // value for 'packageUuid'
 *      variables: // value for 'variables'
 *      version: // value for 'version'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useCreatePackageVersionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePackageVersionMutation, Types.CreatePackageVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePackageVersionMutation, Types.CreatePackageVersionMutationVariables>(CreatePackageVersionDocument, options);
      }
export type CreatePackageVersionMutationHookResult = ReturnType<typeof useCreatePackageVersionMutation>;
export type CreatePackageVersionMutationResult = Apollo.MutationResult<Types.CreatePackageVersionMutation>;
export type CreatePackageVersionMutationOptions = Apollo.BaseMutationOptions<Types.CreatePackageVersionMutation, Types.CreatePackageVersionMutationVariables>;
export const CreatePackageVersionFromPreviousDocument = gql`
    mutation CreatePackageVersionFromPrevious($previousPackageVersionUuid: String!, $newPackageVersionUuid: String!, $version: String!, $createdBy: String!) {
  createPackageVersionFromPrevious(
    uuid: $previousPackageVersionUuid
    args: {newPackageVersionUuid: $newPackageVersionUuid, version: $version, createdBy: $createdBy}
  )
}
    `;
export type CreatePackageVersionFromPreviousMutationFn = Apollo.MutationFunction<Types.CreatePackageVersionFromPreviousMutation, Types.CreatePackageVersionFromPreviousMutationVariables>;

/**
 * __useCreatePackageVersionFromPreviousMutation__
 *
 * To run a mutation, you first call `useCreatePackageVersionFromPreviousMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageVersionFromPreviousMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageVersionFromPreviousMutation, { data, loading, error }] = useCreatePackageVersionFromPreviousMutation({
 *   variables: {
 *      previousPackageVersionUuid: // value for 'previousPackageVersionUuid'
 *      newPackageVersionUuid: // value for 'newPackageVersionUuid'
 *      version: // value for 'version'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useCreatePackageVersionFromPreviousMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePackageVersionFromPreviousMutation, Types.CreatePackageVersionFromPreviousMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePackageVersionFromPreviousMutation, Types.CreatePackageVersionFromPreviousMutationVariables>(CreatePackageVersionFromPreviousDocument, options);
      }
export type CreatePackageVersionFromPreviousMutationHookResult = ReturnType<typeof useCreatePackageVersionFromPreviousMutation>;
export type CreatePackageVersionFromPreviousMutationResult = Apollo.MutationResult<Types.CreatePackageVersionFromPreviousMutation>;
export type CreatePackageVersionFromPreviousMutationOptions = Apollo.BaseMutationOptions<Types.CreatePackageVersionFromPreviousMutation, Types.CreatePackageVersionFromPreviousMutationVariables>;
export const DeletePackageVersionDocument = gql`
    mutation DeletePackageVersion($uuid: String!) {
  deletePackageVersion(uuid: $uuid)
}
    `;
export type DeletePackageVersionMutationFn = Apollo.MutationFunction<Types.DeletePackageVersionMutation, Types.DeletePackageVersionMutationVariables>;

/**
 * __useDeletePackageVersionMutation__
 *
 * To run a mutation, you first call `useDeletePackageVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageVersionMutation, { data, loading, error }] = useDeletePackageVersionMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeletePackageVersionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePackageVersionMutation, Types.DeletePackageVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePackageVersionMutation, Types.DeletePackageVersionMutationVariables>(DeletePackageVersionDocument, options);
      }
export type DeletePackageVersionMutationHookResult = ReturnType<typeof useDeletePackageVersionMutation>;
export type DeletePackageVersionMutationResult = Apollo.MutationResult<Types.DeletePackageVersionMutation>;
export type DeletePackageVersionMutationOptions = Apollo.BaseMutationOptions<Types.DeletePackageVersionMutation, Types.DeletePackageVersionMutationVariables>;
export const DeployPackageVersionDocument = gql`
    mutation DeployPackageVersion($uuid: String!) {
  deployPackageVersion(uuid: $uuid)
}
    `;
export type DeployPackageVersionMutationFn = Apollo.MutationFunction<Types.DeployPackageVersionMutation, Types.DeployPackageVersionMutationVariables>;

/**
 * __useDeployPackageVersionMutation__
 *
 * To run a mutation, you first call `useDeployPackageVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployPackageVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployPackageVersionMutation, { data, loading, error }] = useDeployPackageVersionMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeployPackageVersionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeployPackageVersionMutation, Types.DeployPackageVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeployPackageVersionMutation, Types.DeployPackageVersionMutationVariables>(DeployPackageVersionDocument, options);
      }
export type DeployPackageVersionMutationHookResult = ReturnType<typeof useDeployPackageVersionMutation>;
export type DeployPackageVersionMutationResult = Apollo.MutationResult<Types.DeployPackageVersionMutation>;
export type DeployPackageVersionMutationOptions = Apollo.BaseMutationOptions<Types.DeployPackageVersionMutation, Types.DeployPackageVersionMutationVariables>;
export const UndeployPackageVersionDocument = gql`
    mutation UndeployPackageVersion($uuid: String!) {
  undeployPackageVersion(uuid: $uuid)
}
    `;
export type UndeployPackageVersionMutationFn = Apollo.MutationFunction<Types.UndeployPackageVersionMutation, Types.UndeployPackageVersionMutationVariables>;

/**
 * __useUndeployPackageVersionMutation__
 *
 * To run a mutation, you first call `useUndeployPackageVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeployPackageVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeployPackageVersionMutation, { data, loading, error }] = useUndeployPackageVersionMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useUndeployPackageVersionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UndeployPackageVersionMutation, Types.UndeployPackageVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UndeployPackageVersionMutation, Types.UndeployPackageVersionMutationVariables>(UndeployPackageVersionDocument, options);
      }
export type UndeployPackageVersionMutationHookResult = ReturnType<typeof useUndeployPackageVersionMutation>;
export type UndeployPackageVersionMutationResult = Apollo.MutationResult<Types.UndeployPackageVersionMutation>;
export type UndeployPackageVersionMutationOptions = Apollo.BaseMutationOptions<Types.UndeployPackageVersionMutation, Types.UndeployPackageVersionMutationVariables>;
export const UpdatePackageVersionStatusDocument = gql`
    mutation UpdatePackageVersionStatus($uuid: String!, $status: ContentStatus!) {
  updatePackageVersionStatus(args: {uuid: $uuid, status: $status})
}
    `;
export type UpdatePackageVersionStatusMutationFn = Apollo.MutationFunction<Types.UpdatePackageVersionStatusMutation, Types.UpdatePackageVersionStatusMutationVariables>;

/**
 * __useUpdatePackageVersionStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePackageVersionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageVersionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageVersionStatusMutation, { data, loading, error }] = useUpdatePackageVersionStatusMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdatePackageVersionStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePackageVersionStatusMutation, Types.UpdatePackageVersionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePackageVersionStatusMutation, Types.UpdatePackageVersionStatusMutationVariables>(UpdatePackageVersionStatusDocument, options);
      }
export type UpdatePackageVersionStatusMutationHookResult = ReturnType<typeof useUpdatePackageVersionStatusMutation>;
export type UpdatePackageVersionStatusMutationResult = Apollo.MutationResult<Types.UpdatePackageVersionStatusMutation>;
export type UpdatePackageVersionStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePackageVersionStatusMutation, Types.UpdatePackageVersionStatusMutationVariables>;
export const UpdatePackageVersionVariablesDocument = gql`
    mutation UpdatePackageVersionVariables($uuid: String!, $variables: JSON!) {
  updatePackageVersionVariables(args: {variables: $variables, uuid: $uuid})
}
    `;
export type UpdatePackageVersionVariablesMutationFn = Apollo.MutationFunction<Types.UpdatePackageVersionVariablesMutation, Types.UpdatePackageVersionVariablesMutationVariables>;

/**
 * __useUpdatePackageVersionVariablesMutation__
 *
 * To run a mutation, you first call `useUpdatePackageVersionVariablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageVersionVariablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageVersionVariablesMutation, { data, loading, error }] = useUpdatePackageVersionVariablesMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useUpdatePackageVersionVariablesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePackageVersionVariablesMutation, Types.UpdatePackageVersionVariablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePackageVersionVariablesMutation, Types.UpdatePackageVersionVariablesMutationVariables>(UpdatePackageVersionVariablesDocument, options);
      }
export type UpdatePackageVersionVariablesMutationHookResult = ReturnType<typeof useUpdatePackageVersionVariablesMutation>;
export type UpdatePackageVersionVariablesMutationResult = Apollo.MutationResult<Types.UpdatePackageVersionVariablesMutation>;
export type UpdatePackageVersionVariablesMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePackageVersionVariablesMutation, Types.UpdatePackageVersionVariablesMutationVariables>;
export const ParseSchemaDocument = gql`
    mutation ParseSchema($data: String!, $schema: String!, $env: String) {
  parseData(args: {data: $data, schema: $schema, env: $env})
}
    `;
export type ParseSchemaMutationFn = Apollo.MutationFunction<Types.ParseSchemaMutation, Types.ParseSchemaMutationVariables>;

/**
 * __useParseSchemaMutation__
 *
 * To run a mutation, you first call `useParseSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseSchemaMutation, { data, loading, error }] = useParseSchemaMutation({
 *   variables: {
 *      data: // value for 'data'
 *      schema: // value for 'schema'
 *      env: // value for 'env'
 *   },
 * });
 */
export function useParseSchemaMutation(baseOptions?: Apollo.MutationHookOptions<Types.ParseSchemaMutation, Types.ParseSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ParseSchemaMutation, Types.ParseSchemaMutationVariables>(ParseSchemaDocument, options);
      }
export type ParseSchemaMutationHookResult = ReturnType<typeof useParseSchemaMutation>;
export type ParseSchemaMutationResult = Apollo.MutationResult<Types.ParseSchemaMutation>;
export type ParseSchemaMutationOptions = Apollo.BaseMutationOptions<Types.ParseSchemaMutation, Types.ParseSchemaMutationVariables>;
export const RunMappingDocument = gql`
    mutation RunMapping($data: String!, $mapping: String!, $config_variables: JSON) {
  runMapping(
    args: {data: $data, mapping: $mapping, config_variables: $config_variables}
  ) {
    errors
    items
    duration
    results {
      error
      value
      mapper {
        key
        path
      }
      mapping {
        key
        path
      }
    }
  }
}
    `;
export type RunMappingMutationFn = Apollo.MutationFunction<Types.RunMappingMutation, Types.RunMappingMutationVariables>;

/**
 * __useRunMappingMutation__
 *
 * To run a mutation, you first call `useRunMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runMappingMutation, { data, loading, error }] = useRunMappingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      mapping: // value for 'mapping'
 *      config_variables: // value for 'config_variables'
 *   },
 * });
 */
export function useRunMappingMutation(baseOptions?: Apollo.MutationHookOptions<Types.RunMappingMutation, Types.RunMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RunMappingMutation, Types.RunMappingMutationVariables>(RunMappingDocument, options);
      }
export type RunMappingMutationHookResult = ReturnType<typeof useRunMappingMutation>;
export type RunMappingMutationResult = Apollo.MutationResult<Types.RunMappingMutation>;
export type RunMappingMutationOptions = Apollo.BaseMutationOptions<Types.RunMappingMutation, Types.RunMappingMutationVariables>;
export const ValidateToSchemaDocument = gql`
    mutation ValidateToSchema($data: String!, $schema: String!, $env: String) {
  validateToSchema(args: {data: $data, schema: $schema, env: $env}) {
    valid
    reportingPath
    errors {
      path
      message
    }
    warnings {
      path
      message
    }
  }
}
    `;
export type ValidateToSchemaMutationFn = Apollo.MutationFunction<Types.ValidateToSchemaMutation, Types.ValidateToSchemaMutationVariables>;

/**
 * __useValidateToSchemaMutation__
 *
 * To run a mutation, you first call `useValidateToSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateToSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateToSchemaMutation, { data, loading, error }] = useValidateToSchemaMutation({
 *   variables: {
 *      data: // value for 'data'
 *      schema: // value for 'schema'
 *      env: // value for 'env'
 *   },
 * });
 */
export function useValidateToSchemaMutation(baseOptions?: Apollo.MutationHookOptions<Types.ValidateToSchemaMutation, Types.ValidateToSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ValidateToSchemaMutation, Types.ValidateToSchemaMutationVariables>(ValidateToSchemaDocument, options);
      }
export type ValidateToSchemaMutationHookResult = ReturnType<typeof useValidateToSchemaMutation>;
export type ValidateToSchemaMutationResult = Apollo.MutationResult<Types.ValidateToSchemaMutation>;
export type ValidateToSchemaMutationOptions = Apollo.BaseMutationOptions<Types.ValidateToSchemaMutation, Types.ValidateToSchemaMutationVariables>;
export const CreateWebServiceDocument = gql`
    mutation CreateWebService($uuid: ID!, $packageVersionUuid: String!, $name: String!, $description: String!, $schema: JSON!) {
  createWebService(
    args: {uuid: $uuid, packageVersionUuid: $packageVersionUuid, name: $name, description: $description, schema: $schema}
  )
}
    `;
export type CreateWebServiceMutationFn = Apollo.MutationFunction<Types.CreateWebServiceMutation, Types.CreateWebServiceMutationVariables>;

/**
 * __useCreateWebServiceMutation__
 *
 * To run a mutation, you first call `useCreateWebServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebServiceMutation, { data, loading, error }] = useCreateWebServiceMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useCreateWebServiceMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateWebServiceMutation, Types.CreateWebServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateWebServiceMutation, Types.CreateWebServiceMutationVariables>(CreateWebServiceDocument, options);
      }
export type CreateWebServiceMutationHookResult = ReturnType<typeof useCreateWebServiceMutation>;
export type CreateWebServiceMutationResult = Apollo.MutationResult<Types.CreateWebServiceMutation>;
export type CreateWebServiceMutationOptions = Apollo.BaseMutationOptions<Types.CreateWebServiceMutation, Types.CreateWebServiceMutationVariables>;
export const DeleteWebServiceDocument = gql`
    mutation DeleteWebService($packageVersionUuid: String!, $uuid: String!) {
  deleteWebService(packageVersionUuid: $packageVersionUuid, uuid: $uuid)
}
    `;
export type DeleteWebServiceMutationFn = Apollo.MutationFunction<Types.DeleteWebServiceMutation, Types.DeleteWebServiceMutationVariables>;

/**
 * __useDeleteWebServiceMutation__
 *
 * To run a mutation, you first call `useDeleteWebServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebServiceMutation, { data, loading, error }] = useDeleteWebServiceMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteWebServiceMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteWebServiceMutation, Types.DeleteWebServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteWebServiceMutation, Types.DeleteWebServiceMutationVariables>(DeleteWebServiceDocument, options);
      }
export type DeleteWebServiceMutationHookResult = ReturnType<typeof useDeleteWebServiceMutation>;
export type DeleteWebServiceMutationResult = Apollo.MutationResult<Types.DeleteWebServiceMutation>;
export type DeleteWebServiceMutationOptions = Apollo.BaseMutationOptions<Types.DeleteWebServiceMutation, Types.DeleteWebServiceMutationVariables>;
export const UpdateWebServiceDocument = gql`
    mutation UpdateWebService($packageVersionUuid: String!, $uuid: String!, $schema: JSON, $name: String, $description: String) {
  updateWebService(
    packageVersionUuid: $packageVersionUuid
    args: {uuid: $uuid, name: $name, description: $description, schema: $schema}
  )
}
    `;
export type UpdateWebServiceMutationFn = Apollo.MutationFunction<Types.UpdateWebServiceMutation, Types.UpdateWebServiceMutationVariables>;

/**
 * __useUpdateWebServiceMutation__
 *
 * To run a mutation, you first call `useUpdateWebServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebServiceMutation, { data, loading, error }] = useUpdateWebServiceMutation({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *      schema: // value for 'schema'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateWebServiceMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateWebServiceMutation, Types.UpdateWebServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateWebServiceMutation, Types.UpdateWebServiceMutationVariables>(UpdateWebServiceDocument, options);
      }
export type UpdateWebServiceMutationHookResult = ReturnType<typeof useUpdateWebServiceMutation>;
export type UpdateWebServiceMutationResult = Apollo.MutationResult<Types.UpdateWebServiceMutation>;
export type UpdateWebServiceMutationOptions = Apollo.BaseMutationOptions<Types.UpdateWebServiceMutation, Types.UpdateWebServiceMutationVariables>;
export const GetAllPackageVersionsDocument = gql`
    query GetAllPackageVersions($packageUuid: String!, $limit: Float!, $offset: Float!) {
  getAllPackageVersions(
    args: {packageUuid: $packageUuid, limit: $limit, offset: $offset, orderBy: "modifiedAt", orderType: "DESC"}
  ) {
    data {
      uuid
      version
      status
      modifiedAt
      modifiedBy
      deployedAt
      deployedBy
    }
    limit
    offset
    currentItems
    totalItems
  }
}
    `;

/**
 * __useGetAllPackageVersionsQuery__
 *
 * To run a query within a React component, call `useGetAllPackageVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPackageVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPackageVersionsQuery({
 *   variables: {
 *      packageUuid: // value for 'packageUuid'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAllPackageVersionsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAllPackageVersionsQuery, Types.GetAllPackageVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllPackageVersionsQuery, Types.GetAllPackageVersionsQueryVariables>(GetAllPackageVersionsDocument, options);
      }
export function useGetAllPackageVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllPackageVersionsQuery, Types.GetAllPackageVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllPackageVersionsQuery, Types.GetAllPackageVersionsQueryVariables>(GetAllPackageVersionsDocument, options);
        }
export type GetAllPackageVersionsQueryHookResult = ReturnType<typeof useGetAllPackageVersionsQuery>;
export type GetAllPackageVersionsLazyQueryHookResult = ReturnType<typeof useGetAllPackageVersionsLazyQuery>;
export type GetAllPackageVersionsQueryResult = Apollo.QueryResult<Types.GetAllPackageVersionsQuery, Types.GetAllPackageVersionsQueryVariables>;
export const GetAllPackagesDocument = gql`
    query GetAllPackages($limit: Float!, $offset: Float!) {
  getAllPackages(
    args: {limit: $limit, offset: $offset, orderBy: "modifiedAt", orderType: "DESC"}
  ) {
    data {
      name
      description
      uuid
      createdBy
      modifiedAt
      modifiedBy
    }
    limit
    offset
    currentItems
    totalItems
  }
}
    `;

/**
 * __useGetAllPackagesQuery__
 *
 * To run a query within a React component, call `useGetAllPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPackagesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAllPackagesQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAllPackagesQuery, Types.GetAllPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllPackagesQuery, Types.GetAllPackagesQueryVariables>(GetAllPackagesDocument, options);
      }
export function useGetAllPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllPackagesQuery, Types.GetAllPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllPackagesQuery, Types.GetAllPackagesQueryVariables>(GetAllPackagesDocument, options);
        }
export type GetAllPackagesQueryHookResult = ReturnType<typeof useGetAllPackagesQuery>;
export type GetAllPackagesLazyQueryHookResult = ReturnType<typeof useGetAllPackagesLazyQuery>;
export type GetAllPackagesQueryResult = Apollo.QueryResult<Types.GetAllPackagesQuery, Types.GetAllPackagesQueryVariables>;
export const GetConfigSchemasDocument = gql`
    query GetConfigSchemas {
  getConfigSchemas {
    modelSchema
    flowComponentsSchema
    mappingSchema
  }
}
    `;

/**
 * __useGetConfigSchemasQuery__
 *
 * To run a query within a React component, call `useGetConfigSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigSchemasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigSchemasQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetConfigSchemasQuery, Types.GetConfigSchemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetConfigSchemasQuery, Types.GetConfigSchemasQueryVariables>(GetConfigSchemasDocument, options);
      }
export function useGetConfigSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetConfigSchemasQuery, Types.GetConfigSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetConfigSchemasQuery, Types.GetConfigSchemasQueryVariables>(GetConfigSchemasDocument, options);
        }
export type GetConfigSchemasQueryHookResult = ReturnType<typeof useGetConfigSchemasQuery>;
export type GetConfigSchemasLazyQueryHookResult = ReturnType<typeof useGetConfigSchemasLazyQuery>;
export type GetConfigSchemasQueryResult = Apollo.QueryResult<Types.GetConfigSchemasQuery, Types.GetConfigSchemasQueryVariables>;
export const GetEndpointDocument = gql`
    query GetEndpoint($packageVersionUuid: String!, $uuid: String!) {
  getEndpoint(packageVersionUuid: $packageVersionUuid, uuid: $uuid) {
    uuid
    packageVersionUuid
    webServiceUuid
    schema
    name
    description
    WebService {
      uuid
      packageVersionUuid
      name
      description
      schema
    }
  }
}
    `;

/**
 * __useGetEndpointQuery__
 *
 * To run a query within a React component, call `useGetEndpointQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndpointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndpointQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetEndpointQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEndpointQuery, Types.GetEndpointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEndpointQuery, Types.GetEndpointQueryVariables>(GetEndpointDocument, options);
      }
export function useGetEndpointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEndpointQuery, Types.GetEndpointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEndpointQuery, Types.GetEndpointQueryVariables>(GetEndpointDocument, options);
        }
export type GetEndpointQueryHookResult = ReturnType<typeof useGetEndpointQuery>;
export type GetEndpointLazyQueryHookResult = ReturnType<typeof useGetEndpointLazyQuery>;
export type GetEndpointQueryResult = Apollo.QueryResult<Types.GetEndpointQuery, Types.GetEndpointQueryVariables>;
export const GetEndpointsByPackageVersionDocument = gql`
    query GetEndpointsByPackageVersion($packageVersionUuid: String!, $limit: Float!, $offset: Float!) {
  getEndpointsByPackageVersion(
    args: {packageVersionUuid: $packageVersionUuid, limit: $limit, offset: $offset, orderBy: "modifiedAt", orderType: "DESC"}
  ) {
    data {
      uuid
      packageVersionUuid
      name
      schema
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      WebService {
        uuid
        packageVersionUuid
        name
        schema
      }
    }
    limit
    offset
    currentItems
    totalItems
  }
}
    `;

/**
 * __useGetEndpointsByPackageVersionQuery__
 *
 * To run a query within a React component, call `useGetEndpointsByPackageVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndpointsByPackageVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndpointsByPackageVersionQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetEndpointsByPackageVersionQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEndpointsByPackageVersionQuery, Types.GetEndpointsByPackageVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEndpointsByPackageVersionQuery, Types.GetEndpointsByPackageVersionQueryVariables>(GetEndpointsByPackageVersionDocument, options);
      }
export function useGetEndpointsByPackageVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEndpointsByPackageVersionQuery, Types.GetEndpointsByPackageVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEndpointsByPackageVersionQuery, Types.GetEndpointsByPackageVersionQueryVariables>(GetEndpointsByPackageVersionDocument, options);
        }
export type GetEndpointsByPackageVersionQueryHookResult = ReturnType<typeof useGetEndpointsByPackageVersionQuery>;
export type GetEndpointsByPackageVersionLazyQueryHookResult = ReturnType<typeof useGetEndpointsByPackageVersionLazyQuery>;
export type GetEndpointsByPackageVersionQueryResult = Apollo.QueryResult<Types.GetEndpointsByPackageVersionQuery, Types.GetEndpointsByPackageVersionQueryVariables>;
export const GetEndpointsFromWebServiceDocument = gql`
    query GetEndpointsFromWebService($packageVersionUuid: String!, $webServiceUuid: String!, $limit: Float!, $offset: Float!) {
  getEndpointsByPackageVersion(
    args: {packageVersionUuid: $packageVersionUuid, webServiceUuid: $webServiceUuid, limit: $limit, offset: $offset, orderBy: "modifiedAt", orderType: "DESC"}
  ) {
    data {
      uuid
      packageVersionUuid
      name
      schema
      createdAt
      createdBy
      modifiedAt
      modifiedBy
    }
    limit
    offset
    currentItems
    totalItems
  }
}
    `;

/**
 * __useGetEndpointsFromWebServiceQuery__
 *
 * To run a query within a React component, call `useGetEndpointsFromWebServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndpointsFromWebServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndpointsFromWebServiceQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      webServiceUuid: // value for 'webServiceUuid'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetEndpointsFromWebServiceQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEndpointsFromWebServiceQuery, Types.GetEndpointsFromWebServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEndpointsFromWebServiceQuery, Types.GetEndpointsFromWebServiceQueryVariables>(GetEndpointsFromWebServiceDocument, options);
      }
export function useGetEndpointsFromWebServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEndpointsFromWebServiceQuery, Types.GetEndpointsFromWebServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEndpointsFromWebServiceQuery, Types.GetEndpointsFromWebServiceQueryVariables>(GetEndpointsFromWebServiceDocument, options);
        }
export type GetEndpointsFromWebServiceQueryHookResult = ReturnType<typeof useGetEndpointsFromWebServiceQuery>;
export type GetEndpointsFromWebServiceLazyQueryHookResult = ReturnType<typeof useGetEndpointsFromWebServiceLazyQuery>;
export type GetEndpointsFromWebServiceQueryResult = Apollo.QueryResult<Types.GetEndpointsFromWebServiceQuery, Types.GetEndpointsFromWebServiceQueryVariables>;
export const GetEntityUsageInfoDocument = gql`
    query GetEntityUsageInfo($versionUuid: String!, $entityType: String!, $entityKey: String!) {
  getEntityUsageInfo(
    versionUuid: $versionUuid
    entityType: $entityType
    entityKey: $entityKey
  ) {
    endpoints {
      uuid
      name
      description
    }
    flows {
      uuid
      name
      description
    }
    mappings {
      uuid
      name
      description
    }
    models {
      uuid
      name
      description
    }
  }
}
    `;

/**
 * __useGetEntityUsageInfoQuery__
 *
 * To run a query within a React component, call `useGetEntityUsageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityUsageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityUsageInfoQuery({
 *   variables: {
 *      versionUuid: // value for 'versionUuid'
 *      entityType: // value for 'entityType'
 *      entityKey: // value for 'entityKey'
 *   },
 * });
 */
export function useGetEntityUsageInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEntityUsageInfoQuery, Types.GetEntityUsageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEntityUsageInfoQuery, Types.GetEntityUsageInfoQueryVariables>(GetEntityUsageInfoDocument, options);
      }
export function useGetEntityUsageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEntityUsageInfoQuery, Types.GetEntityUsageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEntityUsageInfoQuery, Types.GetEntityUsageInfoQueryVariables>(GetEntityUsageInfoDocument, options);
        }
export type GetEntityUsageInfoQueryHookResult = ReturnType<typeof useGetEntityUsageInfoQuery>;
export type GetEntityUsageInfoLazyQueryHookResult = ReturnType<typeof useGetEntityUsageInfoLazyQuery>;
export type GetEntityUsageInfoQueryResult = Apollo.QueryResult<Types.GetEntityUsageInfoQuery, Types.GetEntityUsageInfoQueryVariables>;
export const GetEnvironmentDocument = gql`
    query GetEnvironment($uuid: String!) {
  getEnvironment(uuid: $uuid) {
    uuid
    name
    description
  }
}
    `;

/**
 * __useGetEnvironmentQuery__
 *
 * To run a query within a React component, call `useGetEnvironmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnvironmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnvironmentQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetEnvironmentQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEnvironmentQuery, Types.GetEnvironmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEnvironmentQuery, Types.GetEnvironmentQueryVariables>(GetEnvironmentDocument, options);
      }
export function useGetEnvironmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEnvironmentQuery, Types.GetEnvironmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEnvironmentQuery, Types.GetEnvironmentQueryVariables>(GetEnvironmentDocument, options);
        }
export type GetEnvironmentQueryHookResult = ReturnType<typeof useGetEnvironmentQuery>;
export type GetEnvironmentLazyQueryHookResult = ReturnType<typeof useGetEnvironmentLazyQuery>;
export type GetEnvironmentQueryResult = Apollo.QueryResult<Types.GetEnvironmentQuery, Types.GetEnvironmentQueryVariables>;
export const GetEnvironmentByAccountDocument = gql`
    query GetEnvironmentByAccount($limit: Float!, $offset: Float!) {
  getEnvironmentByAccount(
    args: {limit: $limit, offset: $offset, orderBy: "modifiedAt", orderType: "DESC"}
  ) {
    data {
      uuid
      name
      description
      gatewayUrl
    }
    limit
    offset
    currentItems
    totalItems
  }
}
    `;

/**
 * __useGetEnvironmentByAccountQuery__
 *
 * To run a query within a React component, call `useGetEnvironmentByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnvironmentByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnvironmentByAccountQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetEnvironmentByAccountQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEnvironmentByAccountQuery, Types.GetEnvironmentByAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEnvironmentByAccountQuery, Types.GetEnvironmentByAccountQueryVariables>(GetEnvironmentByAccountDocument, options);
      }
export function useGetEnvironmentByAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEnvironmentByAccountQuery, Types.GetEnvironmentByAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEnvironmentByAccountQuery, Types.GetEnvironmentByAccountQueryVariables>(GetEnvironmentByAccountDocument, options);
        }
export type GetEnvironmentByAccountQueryHookResult = ReturnType<typeof useGetEnvironmentByAccountQuery>;
export type GetEnvironmentByAccountLazyQueryHookResult = ReturnType<typeof useGetEnvironmentByAccountLazyQuery>;
export type GetEnvironmentByAccountQueryResult = Apollo.QueryResult<Types.GetEnvironmentByAccountQuery, Types.GetEnvironmentByAccountQueryVariables>;
export const GetExpandedModelSchemaDocument = gql`
    query GetExpandedModelSchema($packageVersionUuid: String!, $uuid: String, $schema: JSON) {
  getExpandedModelSchema(
    packageVersionUuid: $packageVersionUuid
    uuid: $uuid
    schema: $schema
  ) {
    uuid
    schema
  }
}
    `;

/**
 * __useGetExpandedModelSchemaQuery__
 *
 * To run a query within a React component, call `useGetExpandedModelSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpandedModelSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpandedModelSchemaQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useGetExpandedModelSchemaQuery(baseOptions: Apollo.QueryHookOptions<Types.GetExpandedModelSchemaQuery, Types.GetExpandedModelSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetExpandedModelSchemaQuery, Types.GetExpandedModelSchemaQueryVariables>(GetExpandedModelSchemaDocument, options);
      }
export function useGetExpandedModelSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetExpandedModelSchemaQuery, Types.GetExpandedModelSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetExpandedModelSchemaQuery, Types.GetExpandedModelSchemaQueryVariables>(GetExpandedModelSchemaDocument, options);
        }
export type GetExpandedModelSchemaQueryHookResult = ReturnType<typeof useGetExpandedModelSchemaQuery>;
export type GetExpandedModelSchemaLazyQueryHookResult = ReturnType<typeof useGetExpandedModelSchemaLazyQuery>;
export type GetExpandedModelSchemaQueryResult = Apollo.QueryResult<Types.GetExpandedModelSchemaQuery, Types.GetExpandedModelSchemaQueryVariables>;
export const GetFlowDocument = gql`
    query GetFlow($packageVersionUuid: String!, $uuid: String!) {
  getFlow(packageVersionUuid: $packageVersionUuid, uuid: $uuid) {
    uuid
    packageVersionUuid
    schema
    status
    name
    description
  }
}
    `;

/**
 * __useGetFlowQuery__
 *
 * To run a query within a React component, call `useGetFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlowQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetFlowQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFlowQuery, Types.GetFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFlowQuery, Types.GetFlowQueryVariables>(GetFlowDocument, options);
      }
export function useGetFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFlowQuery, Types.GetFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFlowQuery, Types.GetFlowQueryVariables>(GetFlowDocument, options);
        }
export type GetFlowQueryHookResult = ReturnType<typeof useGetFlowQuery>;
export type GetFlowLazyQueryHookResult = ReturnType<typeof useGetFlowLazyQuery>;
export type GetFlowQueryResult = Apollo.QueryResult<Types.GetFlowQuery, Types.GetFlowQueryVariables>;
export const GetFlowsByPackageVersionDocument = gql`
    query GetFlowsByPackageVersion($packageVersionUuid: String!, $limit: Float!, $offset: Float!, $flowType: String) {
  getFlowsByPackageVersion(
    args: {packageVersionUuid: $packageVersionUuid, limit: $limit, offset: $offset, orderBy: "modifiedAt", orderType: "DESC", flowType: $flowType}
  ) {
    data {
      uuid
      packageVersionUuid
      name
      description
      flowType
      schema
      status
      validation
      createdAt
      createdBy
      modifiedAt
      modifiedBy
    }
    limit
    offset
    currentItems
    totalItems
  }
}
    `;

/**
 * __useGetFlowsByPackageVersionQuery__
 *
 * To run a query within a React component, call `useGetFlowsByPackageVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlowsByPackageVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlowsByPackageVersionQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      flowType: // value for 'flowType'
 *   },
 * });
 */
export function useGetFlowsByPackageVersionQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFlowsByPackageVersionQuery, Types.GetFlowsByPackageVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFlowsByPackageVersionQuery, Types.GetFlowsByPackageVersionQueryVariables>(GetFlowsByPackageVersionDocument, options);
      }
export function useGetFlowsByPackageVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFlowsByPackageVersionQuery, Types.GetFlowsByPackageVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFlowsByPackageVersionQuery, Types.GetFlowsByPackageVersionQueryVariables>(GetFlowsByPackageVersionDocument, options);
        }
export type GetFlowsByPackageVersionQueryHookResult = ReturnType<typeof useGetFlowsByPackageVersionQuery>;
export type GetFlowsByPackageVersionLazyQueryHookResult = ReturnType<typeof useGetFlowsByPackageVersionLazyQuery>;
export type GetFlowsByPackageVersionQueryResult = Apollo.QueryResult<Types.GetFlowsByPackageVersionQuery, Types.GetFlowsByPackageVersionQueryVariables>;
export const GetMappingDocument = gql`
    query GetMapping($packageVersionUuid: String!, $uuid: String!) {
  getMapping(packageVersionUuid: $packageVersionUuid, uuid: $uuid) {
    uuid
    packageVersionUuid
    schema
    name
    description
  }
}
    `;

/**
 * __useGetMappingQuery__
 *
 * To run a query within a React component, call `useGetMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMappingQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetMappingQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMappingQuery, Types.GetMappingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMappingQuery, Types.GetMappingQueryVariables>(GetMappingDocument, options);
      }
export function useGetMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMappingQuery, Types.GetMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMappingQuery, Types.GetMappingQueryVariables>(GetMappingDocument, options);
        }
export type GetMappingQueryHookResult = ReturnType<typeof useGetMappingQuery>;
export type GetMappingLazyQueryHookResult = ReturnType<typeof useGetMappingLazyQuery>;
export type GetMappingQueryResult = Apollo.QueryResult<Types.GetMappingQuery, Types.GetMappingQueryVariables>;
export const GetMappingsByPackageVersionDocument = gql`
    query GetMappingsByPackageVersion($packageVersionUuid: String!, $limit: Float!, $offset: Float!) {
  getMappingsByPackageVersion(
    args: {packageVersionUuid: $packageVersionUuid, limit: $limit, offset: $offset, orderBy: "modifiedAt", orderType: "DESC"}
  ) {
    data {
      uuid
      packageVersionUuid
      name
      schema
      createdAt
      createdBy
      modifiedAt
      modifiedBy
    }
    limit
    offset
    currentItems
    totalItems
  }
}
    `;

/**
 * __useGetMappingsByPackageVersionQuery__
 *
 * To run a query within a React component, call `useGetMappingsByPackageVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMappingsByPackageVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMappingsByPackageVersionQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetMappingsByPackageVersionQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMappingsByPackageVersionQuery, Types.GetMappingsByPackageVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMappingsByPackageVersionQuery, Types.GetMappingsByPackageVersionQueryVariables>(GetMappingsByPackageVersionDocument, options);
      }
export function useGetMappingsByPackageVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMappingsByPackageVersionQuery, Types.GetMappingsByPackageVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMappingsByPackageVersionQuery, Types.GetMappingsByPackageVersionQueryVariables>(GetMappingsByPackageVersionDocument, options);
        }
export type GetMappingsByPackageVersionQueryHookResult = ReturnType<typeof useGetMappingsByPackageVersionQuery>;
export type GetMappingsByPackageVersionLazyQueryHookResult = ReturnType<typeof useGetMappingsByPackageVersionLazyQuery>;
export type GetMappingsByPackageVersionQueryResult = Apollo.QueryResult<Types.GetMappingsByPackageVersionQuery, Types.GetMappingsByPackageVersionQueryVariables>;
export const GetMockDataDocument = gql`
    query GetMockData($packageVersionUuid: String!, $uuid: String!) {
  getMockData(packageVersionUuid: $packageVersionUuid, uuid: $uuid) {
    uuid
    packageVersionUuid
    source
    data
    name
    description
    modelUuid
    endpointUuid
    mappingUuid
  }
}
    `;

/**
 * __useGetMockDataQuery__
 *
 * To run a query within a React component, call `useGetMockDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMockDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMockDataQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetMockDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMockDataQuery, Types.GetMockDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMockDataQuery, Types.GetMockDataQueryVariables>(GetMockDataDocument, options);
      }
export function useGetMockDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMockDataQuery, Types.GetMockDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMockDataQuery, Types.GetMockDataQueryVariables>(GetMockDataDocument, options);
        }
export type GetMockDataQueryHookResult = ReturnType<typeof useGetMockDataQuery>;
export type GetMockDataLazyQueryHookResult = ReturnType<typeof useGetMockDataLazyQuery>;
export type GetMockDataQueryResult = Apollo.QueryResult<Types.GetMockDataQuery, Types.GetMockDataQueryVariables>;
export const GetMockDataByPackageVersionDocument = gql`
    query GetMockDataByPackageVersion($packageVersionUuid: String!, $limit: Float!, $offset: Float!, $modelUuid: String, $endpointUuid: String, $mappingUuid: String) {
  getMockDataByPackageVersion(
    args: {packageVersionUuid: $packageVersionUuid, limit: $limit, offset: $offset, orderBy: "modifiedAt", orderType: "DESC", modelUuid: $modelUuid, endpointUuid: $endpointUuid, mappingUuid: $mappingUuid}
  ) {
    data {
      uuid
      packageVersionUuid
      name
      description
      modelUuid
      endpointUuid
      mappingUuid
      source
      data
      createdAt
      createdBy
      modifiedAt
      modifiedBy
    }
    limit
    offset
    currentItems
    totalItems
  }
}
    `;

/**
 * __useGetMockDataByPackageVersionQuery__
 *
 * To run a query within a React component, call `useGetMockDataByPackageVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMockDataByPackageVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMockDataByPackageVersionQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      modelUuid: // value for 'modelUuid'
 *      endpointUuid: // value for 'endpointUuid'
 *      mappingUuid: // value for 'mappingUuid'
 *   },
 * });
 */
export function useGetMockDataByPackageVersionQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMockDataByPackageVersionQuery, Types.GetMockDataByPackageVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMockDataByPackageVersionQuery, Types.GetMockDataByPackageVersionQueryVariables>(GetMockDataByPackageVersionDocument, options);
      }
export function useGetMockDataByPackageVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMockDataByPackageVersionQuery, Types.GetMockDataByPackageVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMockDataByPackageVersionQuery, Types.GetMockDataByPackageVersionQueryVariables>(GetMockDataByPackageVersionDocument, options);
        }
export type GetMockDataByPackageVersionQueryHookResult = ReturnType<typeof useGetMockDataByPackageVersionQuery>;
export type GetMockDataByPackageVersionLazyQueryHookResult = ReturnType<typeof useGetMockDataByPackageVersionLazyQuery>;
export type GetMockDataByPackageVersionQueryResult = Apollo.QueryResult<Types.GetMockDataByPackageVersionQuery, Types.GetMockDataByPackageVersionQueryVariables>;
export const GetModelDocument = gql`
    query GetModel($packageVersionUuid: String!, $uuid: String!, $expand: Boolean = false) {
  getModel(
    packageVersionUuid: $packageVersionUuid
    uuid: $uuid
    expandSchema: $expand
  ) {
    uuid
    packageVersionUuid
    schema
    name
    description
    validation
  }
}
    `;

/**
 * __useGetModelQuery__
 *
 * To run a query within a React component, call `useGetModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *      expand: // value for 'expand'
 *   },
 * });
 */
export function useGetModelQuery(baseOptions: Apollo.QueryHookOptions<Types.GetModelQuery, Types.GetModelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetModelQuery, Types.GetModelQueryVariables>(GetModelDocument, options);
      }
export function useGetModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetModelQuery, Types.GetModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetModelQuery, Types.GetModelQueryVariables>(GetModelDocument, options);
        }
export type GetModelQueryHookResult = ReturnType<typeof useGetModelQuery>;
export type GetModelLazyQueryHookResult = ReturnType<typeof useGetModelLazyQuery>;
export type GetModelQueryResult = Apollo.QueryResult<Types.GetModelQuery, Types.GetModelQueryVariables>;
export const GetModelsByPackageVersionDocument = gql`
    query GetModelsByPackageVersion($packageVersionUuid: String!, $limit: Float!, $offset: Float!, $expand: Boolean = false) {
  getModelsByPackageVersion(
    args: {packageVersionUuid: $packageVersionUuid, limit: $limit, offset: $offset, orderBy: "modifiedAt", orderType: "DESC", expandSchema: $expand}
  ) {
    data {
      uuid
      packageVersionUuid
      name
      schema
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      validation
    }
    limit
    offset
    currentItems
    totalItems
  }
}
    `;

/**
 * __useGetModelsByPackageVersionQuery__
 *
 * To run a query within a React component, call `useGetModelsByPackageVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelsByPackageVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelsByPackageVersionQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      expand: // value for 'expand'
 *   },
 * });
 */
export function useGetModelsByPackageVersionQuery(baseOptions: Apollo.QueryHookOptions<Types.GetModelsByPackageVersionQuery, Types.GetModelsByPackageVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetModelsByPackageVersionQuery, Types.GetModelsByPackageVersionQueryVariables>(GetModelsByPackageVersionDocument, options);
      }
export function useGetModelsByPackageVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetModelsByPackageVersionQuery, Types.GetModelsByPackageVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetModelsByPackageVersionQuery, Types.GetModelsByPackageVersionQueryVariables>(GetModelsByPackageVersionDocument, options);
        }
export type GetModelsByPackageVersionQueryHookResult = ReturnType<typeof useGetModelsByPackageVersionQuery>;
export type GetModelsByPackageVersionLazyQueryHookResult = ReturnType<typeof useGetModelsByPackageVersionLazyQuery>;
export type GetModelsByPackageVersionQueryResult = Apollo.QueryResult<Types.GetModelsByPackageVersionQuery, Types.GetModelsByPackageVersionQueryVariables>;
export const GetPackageDocument = gql`
    query GetPackage($uuid: String!) {
  getPackage(uuid: $uuid) {
    uuid
    name
    description
  }
}
    `;

/**
 * __useGetPackageQuery__
 *
 * To run a query within a React component, call `useGetPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetPackageQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPackageQuery, Types.GetPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPackageQuery, Types.GetPackageQueryVariables>(GetPackageDocument, options);
      }
export function useGetPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPackageQuery, Types.GetPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPackageQuery, Types.GetPackageQueryVariables>(GetPackageDocument, options);
        }
export type GetPackageQueryHookResult = ReturnType<typeof useGetPackageQuery>;
export type GetPackageLazyQueryHookResult = ReturnType<typeof useGetPackageLazyQuery>;
export type GetPackageQueryResult = Apollo.QueryResult<Types.GetPackageQuery, Types.GetPackageQueryVariables>;
export const GetPackageContentInfoDocument = gql`
    query GetPackageContentInfo($packageUuid: String!) {
  getPackageContentInfo(packageUuid: $packageUuid) {
    latestVersion
    latestStatus
    availableVersions
    publishedVersions
  }
}
    `;

/**
 * __useGetPackageContentInfoQuery__
 *
 * To run a query within a React component, call `useGetPackageContentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageContentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageContentInfoQuery({
 *   variables: {
 *      packageUuid: // value for 'packageUuid'
 *   },
 * });
 */
export function useGetPackageContentInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPackageContentInfoQuery, Types.GetPackageContentInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPackageContentInfoQuery, Types.GetPackageContentInfoQueryVariables>(GetPackageContentInfoDocument, options);
      }
export function useGetPackageContentInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPackageContentInfoQuery, Types.GetPackageContentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPackageContentInfoQuery, Types.GetPackageContentInfoQueryVariables>(GetPackageContentInfoDocument, options);
        }
export type GetPackageContentInfoQueryHookResult = ReturnType<typeof useGetPackageContentInfoQuery>;
export type GetPackageContentInfoLazyQueryHookResult = ReturnType<typeof useGetPackageContentInfoLazyQuery>;
export type GetPackageContentInfoQueryResult = Apollo.QueryResult<Types.GetPackageContentInfoQuery, Types.GetPackageContentInfoQueryVariables>;
export const GetPackageVersionDocument = gql`
    query GetPackageVersion($uuid: String!) {
  getPackageVersion(uuid: $uuid) {
    uuid
    accountUuid
    packageUuid
    variables
    version
    status
    createdAt
    createdBy
    modifiedAt
    modifiedBy
    deployedAt
    deployedBy
  }
}
    `;

/**
 * __useGetPackageVersionQuery__
 *
 * To run a query within a React component, call `useGetPackageVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageVersionQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetPackageVersionQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPackageVersionQuery, Types.GetPackageVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPackageVersionQuery, Types.GetPackageVersionQueryVariables>(GetPackageVersionDocument, options);
      }
export function useGetPackageVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPackageVersionQuery, Types.GetPackageVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPackageVersionQuery, Types.GetPackageVersionQueryVariables>(GetPackageVersionDocument, options);
        }
export type GetPackageVersionQueryHookResult = ReturnType<typeof useGetPackageVersionQuery>;
export type GetPackageVersionLazyQueryHookResult = ReturnType<typeof useGetPackageVersionLazyQuery>;
export type GetPackageVersionQueryResult = Apollo.QueryResult<Types.GetPackageVersionQuery, Types.GetPackageVersionQueryVariables>;
export const GetPackageVersionContentInfoDocument = gql`
    query GetPackageVersionContentInfo($versionUuid: String!) {
  getPackageVersionContentInfo(versionUuid: $versionUuid) {
    endpoints
    flows
    mappings
    models
    webServices
  }
}
    `;

/**
 * __useGetPackageVersionContentInfoQuery__
 *
 * To run a query within a React component, call `useGetPackageVersionContentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageVersionContentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageVersionContentInfoQuery({
 *   variables: {
 *      versionUuid: // value for 'versionUuid'
 *   },
 * });
 */
export function useGetPackageVersionContentInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPackageVersionContentInfoQuery, Types.GetPackageVersionContentInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPackageVersionContentInfoQuery, Types.GetPackageVersionContentInfoQueryVariables>(GetPackageVersionContentInfoDocument, options);
      }
export function useGetPackageVersionContentInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPackageVersionContentInfoQuery, Types.GetPackageVersionContentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPackageVersionContentInfoQuery, Types.GetPackageVersionContentInfoQueryVariables>(GetPackageVersionContentInfoDocument, options);
        }
export type GetPackageVersionContentInfoQueryHookResult = ReturnType<typeof useGetPackageVersionContentInfoQuery>;
export type GetPackageVersionContentInfoLazyQueryHookResult = ReturnType<typeof useGetPackageVersionContentInfoLazyQuery>;
export type GetPackageVersionContentInfoQueryResult = Apollo.QueryResult<Types.GetPackageVersionContentInfoQuery, Types.GetPackageVersionContentInfoQueryVariables>;
export const GetRuntimeLogsDocument = gql`
    query GetRuntimeLogs($versionUuid: String!, $startDate: DateTime, $limit: Float!, $offset: Float!) {
  getRuntimeLogs(
    args: {packageVersionUuid: $versionUuid, startDate: $startDate, limit: $limit, offset: $offset, orderBy: "time", orderType: "DESC"}
  ) {
    data {
      time
      tag
      flowUuid
      data
    }
    limit
    offset
    currentItems
    totalItems
  }
}
    `;

/**
 * __useGetRuntimeLogsQuery__
 *
 * To run a query within a React component, call `useGetRuntimeLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRuntimeLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRuntimeLogsQuery({
 *   variables: {
 *      versionUuid: // value for 'versionUuid'
 *      startDate: // value for 'startDate'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetRuntimeLogsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRuntimeLogsQuery, Types.GetRuntimeLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRuntimeLogsQuery, Types.GetRuntimeLogsQueryVariables>(GetRuntimeLogsDocument, options);
      }
export function useGetRuntimeLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRuntimeLogsQuery, Types.GetRuntimeLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRuntimeLogsQuery, Types.GetRuntimeLogsQueryVariables>(GetRuntimeLogsDocument, options);
        }
export type GetRuntimeLogsQueryHookResult = ReturnType<typeof useGetRuntimeLogsQuery>;
export type GetRuntimeLogsLazyQueryHookResult = ReturnType<typeof useGetRuntimeLogsLazyQuery>;
export type GetRuntimeLogsQueryResult = Apollo.QueryResult<Types.GetRuntimeLogsQuery, Types.GetRuntimeLogsQueryVariables>;
export const GetWebServiceDocument = gql`
    query getWebService($packageVersionUuid: String!, $uuid: String!) {
  getWebService(uuid: $uuid, packageVersionUuid: $packageVersionUuid) {
    uuid
    packageVersionUuid
    schema
    name
    description
  }
}
    `;

/**
 * __useGetWebServiceQuery__
 *
 * To run a query within a React component, call `useGetWebServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebServiceQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetWebServiceQuery(baseOptions: Apollo.QueryHookOptions<Types.GetWebServiceQuery, Types.GetWebServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetWebServiceQuery, Types.GetWebServiceQueryVariables>(GetWebServiceDocument, options);
      }
export function useGetWebServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWebServiceQuery, Types.GetWebServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetWebServiceQuery, Types.GetWebServiceQueryVariables>(GetWebServiceDocument, options);
        }
export type GetWebServiceQueryHookResult = ReturnType<typeof useGetWebServiceQuery>;
export type GetWebServiceLazyQueryHookResult = ReturnType<typeof useGetWebServiceLazyQuery>;
export type GetWebServiceQueryResult = Apollo.QueryResult<Types.GetWebServiceQuery, Types.GetWebServiceQueryVariables>;
export const GetWebServicesByPackageVersionDocument = gql`
    query GetWebServicesByPackageVersion($packageVersionUuid: String!, $limit: Float!, $offset: Float!) {
  getWebServicesByPackageVersion(
    args: {packageVersionUuid: $packageVersionUuid, limit: $limit, offset: $offset, orderBy: "modifiedAt", orderType: "DESC"}
  ) {
    data {
      uuid
      packageVersionUuid
      name
      description
      schema
      createdAt
      createdBy
      modifiedAt
      modifiedBy
    }
    limit
    offset
    currentItems
    totalItems
  }
}
    `;

/**
 * __useGetWebServicesByPackageVersionQuery__
 *
 * To run a query within a React component, call `useGetWebServicesByPackageVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebServicesByPackageVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebServicesByPackageVersionQuery({
 *   variables: {
 *      packageVersionUuid: // value for 'packageVersionUuid'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetWebServicesByPackageVersionQuery(baseOptions: Apollo.QueryHookOptions<Types.GetWebServicesByPackageVersionQuery, Types.GetWebServicesByPackageVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetWebServicesByPackageVersionQuery, Types.GetWebServicesByPackageVersionQueryVariables>(GetWebServicesByPackageVersionDocument, options);
      }
export function useGetWebServicesByPackageVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWebServicesByPackageVersionQuery, Types.GetWebServicesByPackageVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetWebServicesByPackageVersionQuery, Types.GetWebServicesByPackageVersionQueryVariables>(GetWebServicesByPackageVersionDocument, options);
        }
export type GetWebServicesByPackageVersionQueryHookResult = ReturnType<typeof useGetWebServicesByPackageVersionQuery>;
export type GetWebServicesByPackageVersionLazyQueryHookResult = ReturnType<typeof useGetWebServicesByPackageVersionLazyQuery>;
export type GetWebServicesByPackageVersionQueryResult = Apollo.QueryResult<Types.GetWebServicesByPackageVersionQuery, Types.GetWebServicesByPackageVersionQueryVariables>;
export const OnManagementCommandLogLineAddedDocument = gql`
    subscription OnManagementCommandLogLineAdded($uuid: String!, $exchangeName: String!, $queueName: String!) {
  managementCommandLogLineAdded(
    args: {uuid: $uuid, exchangeName: $exchangeName, queueName: $queueName}
  ) {
    uuid
    instanceId
    instanceType
    action
    message
  }
}
    `;

/**
 * __useOnManagementCommandLogLineAddedSubscription__
 *
 * To run a query within a React component, call `useOnManagementCommandLogLineAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnManagementCommandLogLineAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnManagementCommandLogLineAddedSubscription({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      exchangeName: // value for 'exchangeName'
 *      queueName: // value for 'queueName'
 *   },
 * });
 */
export function useOnManagementCommandLogLineAddedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.OnManagementCommandLogLineAddedSubscription, Types.OnManagementCommandLogLineAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.OnManagementCommandLogLineAddedSubscription, Types.OnManagementCommandLogLineAddedSubscriptionVariables>(OnManagementCommandLogLineAddedDocument, options);
      }
export type OnManagementCommandLogLineAddedSubscriptionHookResult = ReturnType<typeof useOnManagementCommandLogLineAddedSubscription>;
export type OnManagementCommandLogLineAddedSubscriptionResult = Apollo.SubscriptionResult<Types.OnManagementCommandLogLineAddedSubscription>;
export const OnRequestLogLineAddedDocument = gql`
    subscription OnRequestLogLineAdded($uuid: String!) {
  requestLogLineAdded(args: {uuid: $uuid}) {
    uuid
    date
    log
  }
}
    `;

/**
 * __useOnRequestLogLineAddedSubscription__
 *
 * To run a query within a React component, call `useOnRequestLogLineAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnRequestLogLineAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnRequestLogLineAddedSubscription({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useOnRequestLogLineAddedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.OnRequestLogLineAddedSubscription, Types.OnRequestLogLineAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.OnRequestLogLineAddedSubscription, Types.OnRequestLogLineAddedSubscriptionVariables>(OnRequestLogLineAddedDocument, options);
      }
export type OnRequestLogLineAddedSubscriptionHookResult = ReturnType<typeof useOnRequestLogLineAddedSubscription>;
export type OnRequestLogLineAddedSubscriptionResult = Apollo.SubscriptionResult<Types.OnRequestLogLineAddedSubscription>;